import { gql } from '@apollo/client';

export const GET_ADS_FOR_EXPORT = gql`
  query GET_ADS_FOR_EXPORT(
    $filterOptions: AdFilterOptionsV5
    $sort: AdSortOptionV5
    $order: OrderOption
    $limit: Int
    $offset: Int
  ) {
    ads: adsV5(
      filterOptions: $filterOptions
      sortOptions: { sort: $sort, order: $order }
      paginationOptions: { limit: $limit, offset: $offset }
    ) {
      edges {
        node {
          __typename
          id
          name
          type
          review
          status
          startDate
          endDate
          unDeletable
          schedule {
            timezone
            deliveryInViewerTime
            dateRangeList {
              startDate
              endDate
              pacingShare
            }
            dayPartList {
              activeDayList
              firstActiveHour
              lastActiveHour
            }
          }
          frequencyCapList {
            type
            limit
            duration
            durationUnit
            enabled
          }
          createdAt
          creative {
            id
            review
            type
            metadata {
              countryCodes
              createdAt
              creativeId
              deleted
              isLegalApproved
              updatedAt
            }
          }
          updatedAt
          lineItem {
            startDate
            endDate
            id
            name
            adProduct
            inventoryBlockId
            parentLineOmsLink {
              id
            }
            lineOmsLink {
              id
              type
            }
            campaign {
              name
              id
              adAccount {
                id
                timezone
                organizationId
              }
              campaignTagList {
                id
                type
                url
              }
              crmLink {
                id
                name
              }
              startDate
            }
            schedule {
              timezone
              dateRangeList {
                startDate
                endDate
                pacingShare
              }
              dayPartList {
                firstActiveHour
                lastActiveHour
                activeDayList
              }
              deliveryInViewerTime
            }
            displayPublisherTarget
            billableThirdParty
            isCoppaOrCaru
            country
            countries
          }
          viewabilityVendorList
          sequence
          adRotation {
            rotationName
            rotationId
            weight
          }
          adSequence {
            adId
            sequenceId
            order
            name
            updatedAt
            podPosition
            podAlignment
          }
          trackingId
          displayPublisherTarget
          hasMisalignedSchedule
          hasInvalidPublisher
          hasInvalidCountry
          countriesTarget
          adTagList {
            id
            type
            event
            url
            isVerified
            unDeletable
            autoVerified
            isIas
          }
        }
      }
      total
    }
  }
`;
